import React, {Component} from 'react';
import {actionCreators} from '../../store/Account';
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'

class RedirectHandler extends Component {

    getUrl = () => {

        const {account, path} = this.props;
        switch (path) {
            case '/user/Home.aspx':
                return `/accounts/${account}`;

            case '/user/makepayment.aspx':
                return `/billing/${account}/makeapayment`;

            case '/user/accountadmin.aspx':
                return `/accounts/${account}/edit`;

            case '/user/BuyoutQuote.aspx':
                return `/billing/${account}/buyoutquote`;

            case '/user/userprofile.aspx':
                return `/profile`;

            case '/user/PaymentHistory.aspx':
                return `/billing/${account}/`;

            case '/user/Documents.aspx':
                return `/documents/${account}`;

            case '/User/OnlineRegistration.aspx':
                return '/register';

            case '/Login.aspx':
                return '/login';

            case '/User/ForgotPassword.aspx':
                return '/forgotpassword';

            default:
                break;
        }
    }

    render() {

        if (this.props.notRelatedToAccount || this.props.account) {
            return <Redirect to={this.getUrl()}></Redirect>
        }
        return (
            <div>
                Redirecting to new URL...
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    account: state.account && state.account.account
        ? state.account.account.value
        : null
});

const mapDispatchToProps = dispatch => ({
    accountSelected: (account) => dispatch(actionCreators.accountSelected(account))
});

export default connect(mapStateToProps, mapDispatchToProps)(RedirectHandler);
